import React from 'react';
import visa from '../assets/logo/Visa.png'
import mastercard from '../assets/logo/Mastercard.png'
import paypal from '../assets/logo/Paypal.png'
import bancontact from '../assets/logo/Bancontact.png'
import logo from '../assets/logo/logo.png'
import { CONTACT_CONFIG } from '../config/contact';

// Utilisation des variables de configuration centralisées
const contactInfo = CONTACT_CONFIG;

export default function Footer() {
    return (
        <footer className="bg-gradient-to-br from-[#0a1a5f] via-[#002f9c] to-[#0d47ff] text-white relative overflow-hidden">
            {/* Background Pattern */}
            <div className="absolute inset-0 opacity-10">
                <div className="h-64 w-full" style={{
                    backgroundImage: `radial-gradient(circle, #3b82f6 1px, transparent 1px)`,
                    backgroundSize: '20px 20px'
                }}></div>
            </div>
            
            <div className="main-content w-[90%] sm:w-[90%] md:w-[85%] m-auto relative z-10">
                {/* Main Footer Content */}
                <div className="py-12 sm:py-16">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
                        
                        {/* Company Info */}
                        <div className="lg:col-span-1">
                            <div className="mb-6">
                                <a href="/" className="flex items-center gap-2 mb-4">
                                    <img src={logo} alt="Logo" loading="lazy" className="footer-logo w-8 h-auto md:w-12 md:h-auto" />
                                    <h3 className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-400">
                                        {contactInfo.companyName}
                                    </h3>
                                </a>
                                <p className="text-sm text-gray-300 leading-relaxed max-w-md">
                                    El mejor servicio IPTV Premium en Europa. Disfruta de más de 79,000 canales 
                                    y 249,000 películas y series en calidad 4K/Full HD.
                                </p>
                            </div>
                            
                            {/* Contact Info */}
                            <div className="space-y-3">
                                <div className="flex items-center space-x-3">
                                    <svg className="w-5 h-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
                                        <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"/>
                                        <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"/>
                                    </svg>
                                    <span className="text-sm text-gray-300">{contactInfo.email}</span>
                                </div>
                                
                                <a href={contactInfo.whatsappUrl} target="_blank" rel="noopener noreferrer" className="flex items-center space-x-3">
                                    <svg className="w-5 h-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
                                        <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"/>
                                    </svg>
                                    <span className="text-sm text-gray-300">{contactInfo.phoneNumber}</span>
                                </a>
                                
                                <div className="flex items-center space-x-3">
                                    <svg className="w-5 h-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd"/>
                                    </svg>
                                    <span className="text-sm text-gray-300">Europa, España</span>
                                </div>
                            </div>
                        </div>
                        
                        {/* Quick Links */}
                        <div className="lg:col-span-1">
                            <h4 className="text-lg font-bold text-white mb-6">Enlaces Rápidos</h4>
                            <ul className="space-y-3">
                                <li>
                                    <button 
                                        onClick={() => document.getElementById('home')?.scrollIntoView({ behavior: 'smooth' })}
                                        className="text-sm text-gray-300 hover:text-yellow-400 transition-colors duration-300 cursor-pointer"
                                    >
                                        Inicio
                                    </button>
                                </li>
                                <li>
                                    <button 
                                        onClick={() => document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' })}
                                        className="text-sm text-gray-300 hover:text-yellow-400 transition-colors duration-300 cursor-pointer"
                                    >
                                        Precios
                                    </button>
                                </li>
                                <li>
                                    <button 
                                        onClick={() => document.getElementById('devices')?.scrollIntoView({ behavior: 'smooth' })}
                                        className="text-sm text-gray-300 hover:text-yellow-400 transition-colors duration-300 cursor-pointer"
                                    >
                                        Dispositivos
                                    </button>
                                </li>
                                <li>
                                    <button 
                                        onClick={() => document.getElementById('faq')?.scrollIntoView({ behavior: 'smooth' })}
                                        className="text-sm text-gray-300 hover:text-yellow-400 transition-colors duration-300 cursor-pointer"
                                    >
                                        FAQ
                                    </button>
                                </li>
                                <li>
                                    <button 
                                        onClick={() => document.getElementById('reviews')?.scrollIntoView({ behavior: 'smooth' })}
                                        className="text-sm text-gray-300 hover:text-yellow-400 transition-colors duration-300 cursor-pointer"
                                    >
                                        Reseñas
                                    </button>
                                </li>
                            </ul>
                        </div>
                        
                        {/* Legal & Support */}
                        <div className="lg:col-span-1">
                            <h4 className="text-lg font-bold text-white mb-6">Legal & Soporte</h4>
                            <ul className="space-y-3">
                                <li>
                                    <a href="/privacy-policy" className="text-sm text-gray-300 hover:text-yellow-400 transition-colors duration-300">
                                        Política de Privacidad
                                    </a>
                                </li>
                                <li>
                                    <a href="/refund-policy" className="text-sm text-gray-300 hover:text-yellow-400 transition-colors duration-300">
                                        Política de Reembolso
                                    </a>
                                </li>
                                <li>
                                    <a href="/terms-conditions" className="text-sm text-gray-300 hover:text-yellow-400 transition-colors duration-300">
                                        Términos y Condiciones
                                    </a>
                                </li>
                            </ul>
                        </div>
                        {/* Payment Methods */}
                        <div className="lg:col-span-1">
                                <div className="text-center">
                                    <h4 className="text-start text-lg font-bold text-white mb-6">Métodos de Pago Aceptados</h4>
                                    <div className="flex justify-start items-center gap-4">
                                        {/* Payment Icons */}
                                        <div className="flex items-center space-x-2 bg-white rounded-lg px-4 py-2 hover:bg-white/20 transition-colors duration-300">
                                            <img src={visa} alt="Visa" className="w-12 h-8 object-contain" />
                                        </div>
                                        
                                        <div className="flex items-center space-x-2 bg-white rounded-lg px-4 py-2 hover:bg-white/20 transition-colors duration-300">
                                            <img src={mastercard} alt="Mastercard" className="w-12 h-8 object-contain" />
                                        </div>
                                        
                                        <div className="flex items-center space-x-2 bg-white rounded-lg px-4 py-2 hover:bg-white/20 transition-colors duration-300">
                                            <img src={paypal} alt="PayPal" className="w-12 h-8 object-contain" />
                                        </div>
                                        
                                        <div className="flex items-center space-x-2 bg-white rounded-lg px-4 py-2 hover:bg-white/20 transition-colors duration-300">
                                            <img src={bancontact} alt="Bancontact" className="w-12 h-8 object-contain" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </div>
                    
                    
                </div>
                
                {/* Bottom Bar */}
                <div className="py-6 border-t border-white/20">
                    <div className="flex flex-col sm:flex-row justify-center items-center space-y-4 sm:space-y-0">
                        <div className="text-center sm:text-left">
                            <p className="text-sm text-gray-300">
                                © 2024 {contactInfo.companyName}. Todos los derechos reservados.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}
